"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M21.72.051a.5.5 0 0 1 .254.291l1 3a.5.5 0 0 1-.316.632L4.924 9.885 4.95 10H23.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5l-.5-.001V23.5a.5.5 0 0 1-.5.5h-19a.5.5 0 0 1-.5-.5v-9.501L2.5 14a.5.5 0 0 1-.5-.5v-.55a2.505 2.505 0 0 1-2-2.45c0-1.023.619-1.906 1.502-2.292l-.355-.354a.502.502 0 0 1 .188-.826l20-7a.5.5 0 0 1 .385.023ZM22 14H4v9h18v-9Zm-1.5 7a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Zm-9 0a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Zm-.842-5.975a.5.5 0 0 1 .316.632L10.194 18H11.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V19H9.5a.499.499 0 0 1-.474-.659l1-3a.499.499 0 0 1 .632-.316ZM7.5 15a.5.5 0 0 1 0 1H6v1h.5c.827 0 1.5.673 1.5 1.5S7.327 20 6.5 20h-1a.5.5 0 0 1 0-1h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h2Zm13 3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6Zm0-3a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1h6ZM7.292 10.999 4.95 11a2.51 2.51 0 0 1-.043.176l-.054.169-.067.167-.068.14-.079.14-.088.135-.022.032c-.12.167-.261.319-.419.452l-.184.141-.139.09-.131.074-.181.086-.163.063-.174.052L3 12.95V13l2.292-.001 2-2Zm4 0H8.706l-2 2h2.586l2-2Zm4 0h-2.586l-2 2h2.586l2-2Zm4 0h-2.586l-2 2h2.586l2-2ZM23 11l-2.294-.001-2 2h2.586L23 11.291V11ZM2.5 9C1.673 9 1 9.673 1 10.5S1.673 12 2.5 12 4 11.327 4 10.5 3.327 9 2.5 9Zm1.88-1.98-1.964.689.301.3a2.5 2.5 0 0 1 1.765.968l1.89-.629L4.38 7.02Zm3.894-1.362-2.712.949 2.011 1.341 2.92-.973-2.219-1.317Zm3.64-1.274-2.407.842 2.241 1.33 2.451-.817-2.285-1.355Zm3.613-1.265-2.379.833L15.25 5.2a.498.498 0 0 1 .15.138l2.47-.822-2.287-1.356-.056-.041Zm5.659-1.979-4.432 1.55 2.335 1.386.031.023 2.748-.915-.682-2.044Z",
    clipRule: "evenodd"
  })]
});